import React from 'react';
import { ThemeProvider } from 'styled-components';
import GlobalStyle from './theme/globalStyle';
import * as themes from './theme';

const Layout: React.FC = ({ children }) => {
  return (
    <ThemeProvider theme={themes.normalTheme}>
      <GlobalStyle />
      <main>{children}</main>
    </ThemeProvider>
  );
};

export default Layout;
